import http from '../../services/http-common';

class AdditionalPaymentService {
  getAdditionalPaymentForList(id) {
    return http.get(`/AdditionalPayment/db/table`);
  }
  insert(data) {
    return http.post(`/AdditionalPayment/db/add`, data);
  }
  update(data) {
    return http.put(`/AdditionalPayment/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/AdditionalPayment/db/delete/${PropertyID}`);
  }
}

export default new AdditionalPaymentService();